import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      meta: {
        title: '首页'
      },
      component: resolve => {
        require(['@/views/home/index.vue'], resolve)
      }
    },
    {
      path: '/risk',
      name: 'risk',
      meta: {
        title: '大数据风控'
      },
      component: resolve => {
        require(['@/views/risk/index.vue'], resolve)
      }
    },
    {
      path: '/contact',
      name: 'contact',
      meta: {
        title: '联系方式'
      },
      component: resolve => {
        require(['@/views/contact/index.vue'], resolve)
      }
    },
    {
      path: '/saas',
      name: 'saas',
      meta: {
        title: 'saas服务'
      },
      component: resolve => {
        require(['@/views/saas/index.vue'], resolve)
      }
    },
    {
      path: '/privacy_policy',
      name: 'privacy_policy',
      meta: {
        title: 'privacy_policy'
      },
      component: resolve => {
        require(['@/views/privacy_policy/index.vue'], resolve)
      }
    },
    {
      path: '/terms_of_service',
      name: 'terms_of_service',
      meta: {
        title: 'terms_of_service'
      },
      component: resolve => {
        require(['@/views/terms_of_service/index.vue'], resolve)
      }
    },
    {
      path: '/loan_agreement',
      name: 'loan_agreement',
      meta: {
        title: 'loan_agreement'
      },
      component: resolve => {
        require(['@/views/loan_agreement/index.vue'], resolve)
      }
    },
    {
      path: '/company_info',
      name: 'company_info',
      meta: {
        title: 'company_info'
      },
      component: resolve => {
        require(['@/views/company_info/index.vue'], resolve)
      }
    },
    {
      path: '/bank_info',
      name: 'bank_info',
      meta: {
        title: 'bank_info'
      },
      component: resolve => {
        require(['@/views/bank_info/index.vue'], resolve)
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js